import axios from 'axios'

const http = axios.create({

    baseURL: '/api/v1'

})

// In axios v1.x erben create()-Instanzen keine Änderungen an axios.defaults mehr.
// Daher wird der Authorization-Header bei jedem Request frisch aus dem localStorage gelesen.
// vue-ls serialisiert Werte als {"value":"...","expire":null}, daher JSON.parse nötig.
http.interceptors.request.use(config => {
    const raw = localStorage.getItem('zmk_token')
    if (raw) {
        try {
            const token = JSON.parse(raw).value
            if (token) {
                config.headers['Authorization'] = token
            }
        } catch (e) {
            // ignore – kein gültiges vue-ls Format
        }
    }
    return config
})

export default http
